import { useTranslation } from "react-i18next";
import { StatCard } from "../../components/neu/StatCard";
import { formatMoney } from "./Money";
import { useAcctCurrency } from "./useAcctCurrency";

// بطاقة KPI محاسبية بأسلوب HELCOO 3D Neu (StatCard الملوّن).
export const StatTile = ({ labelKey, value, tone = "sky", icon, testId, currency, hintKey }) => {
  const { t } = useTranslation();
  const fallback = useAcctCurrency();
  const code = (currency || fallback).toUpperCase();
  return (
    <StatCard testId={testId}
              label={t(labelKey)}
              value={formatMoney(value, code)}
              tone={tone} icon={icon}
              hint={hintKey ? t(hintKey) : undefined} />
  );
};
